import type { GameState } from "../../types";

export const tutorialReducer = (state: GameState, action: any): GameState => {
  switch (action.type) {
    case "START_TUTORIAL":
      return {
        ...state,
        tutorialState: {
          ...state.tutorialState,
          isTutorialActive: true,
          currentTutorial: { id: action.tutorialId, step: 0 },
        },
      };

    case "UPDATE_TUTORIAL_STATE":
      return {
        ...state,
        tutorialState: action.newState.tutorialState,
      };

    default:
      return state;
  }
};
